import { createFileRoute, redirect } from "@tanstack/react-router"

import { parseRouteFocus } from "@/lib/routed-collection-layout"

// LEGACY REDIRECT: the audience now lives in the URL path. Old
// `/channels/$channelId` URLs land on the GUEST audience by default; staff who
// want the internal variant navigate via the in-app rail. Carries `?focus`.
export const Route = createFileRoute("/$orgSlug/$eventSlug/channels/$channelId")({
  validateSearch: (s: Record<string, unknown>): { focus?: number } => ({
    focus: parseRouteFocus(s.focus),
  }),
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/$orgSlug/$eventSlug/channels/guest/$channelId",
      params: { ...params, channelId: params.channelId },
      search: { focus: search.focus },
    })
  },
})
